import dayjs, { Dayjs } from "dayjs";

const storageKey = "first_notification_permission_requested_at";

export const firstNotificationPermissionRequested = ({ storage }: { storage?: Storage }) => {
  if (!storage) return true;

  const value = storage.getItem(storageKey);

  // NOTE: ひとまず通知権限が最初に要求された時間を保存するがその時間を利用するケースは無いため、単純に値の有無を返す
  return !!value;
};

export const setNotificationPermissionRequestedAt = ({
  storage,
  storedAt = dayjs(),
}: {
  storage: Storage;
  storedAt?: Dayjs;
}) => {
  storage.setItem(storageKey, storedAt.unix().toString());
};
